export var Role;
(function (Role) {
    Role["SUPERADMIN"] = "ROLE_SUPERADMIN";
    Role["ADMIN"] = "ROLE_ADMIN";
    Role["THERAPIST"] = "ROLE_THERAPIST";
    Role["MANAGEMENT"] = "ROLE_MANAGEMENT";
    Role["PATIENT"] = "ROLE_PATIENT";
    Role["PREVENTION"] = "ROLE_PREVENTION";
    /**
     * Versand operator (#1612): the account that operates the §302 Versand at
     * Therame. A role of its own on an account of its own, without office and
     * without Standort, never an extra permission of the SUPERADMIN. In every
     * practice ability it gets a branch that grants nothing; its permissions live
     * in the Versand ability.
     */
    Role["TRANSMISSION_OPERATOR"] = "ROLE_TRANSMISSION_OPERATOR";
})(Role || (Role = {}));
//# sourceMappingURL=role.enum.js.map